export const LABEL_COLORS = [
  '#296073', //dark blue
  '#3596b5', //blue
  '#adc5cf', //light blue
  '#9b89b3', //purple
  '#d43725', // red
  '#c34a36', // orange
  '#ffc75f', // yellow
  '#c34a36', // dark orange
  '#008d82', // green
  '#d5cabd',
  '#4b4453', // dark navy
  '#7e4e60', // purple
  '#bdcfb5',
  '#c3dfe0', // light blue
  '#7d6d61', // dim gray
  '#5E574D', // wainut brown
  '#A8C686', // olivine
  '#F0F8EA', // honeydew
  '#9D9C62', // moss green
  '#EDCF5E', // naples yellow
  '#F4A261', // burnt orange
  '#E76F51', // coral
  '#264653', // dark teal
  '#2A9D8F', // teal
  '#E9C46A', // gold
  '#F4A261', // burnt orange
  '#E4572E', // flame
  '#B95F89', // mulberry
  '#7D4698', // eggplant
  '#C2B280', // khaki
  '#D5BDAF', // taupe
  '#967052', // chestnut
  '#D4A572', // tan
  '#8B6914', // mustard
  '#114B5F', // dark teal
  '#e4fde1', // Nyanza
  '#6b2737', // wine
  '#363537', // jet
  '#434758', // space gray
  '#54494B', // ebony clay
  '#ddd1c7', // timber wolf
];

// Helper function to get a random color from the LABEL_COLORS array
export const getRandomColor = (
  excludeColors: Set<string> = new Set()
): string => {
  const availableColors = LABEL_COLORS.filter(
    (color) => !excludeColors.has(color)
  );
  const randomIndex = Math.floor(Math.random() * availableColors.length);
  return availableColors[randomIndex];
};

// Helper function to load project color mapping from IndexedDB
export const loadProjectColorMapping = async (
  projectId: string
): Promise<Record<string, string>> => {
  try {
    const { loadProjectColorMappingFromIndexedDB } = await import('./indexeddb.helpers');
    return await loadProjectColorMappingFromIndexedDB(projectId);
  } catch (error) {
    console.error('Error loading project color mapping:', error);
    return {};
  }
};

// Helper function to save project color mapping to IndexedDB
export const saveProjectColorMapping = async (
  projectId: string,
  projectColorMapping: Record<string, string>
): Promise<void> => {
  try {
    const { saveProjectColorMappingToIndexedDB } = await import('./indexeddb.helpers');
    await saveProjectColorMappingToIndexedDB(projectId, projectColorMapping);
  } catch (error) {
    console.error('Error saving project color mapping:', error);
    // Don't throw - allow the operation to fail silently
  }
};
